import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTranslationDir } from '../../hooks/useTranslationDir';

export const CategoryTotalsCard = ({ categoryTotals }) => {
  const { t, i18n } = useTranslation();
  const { isRTL } = useTranslationDir();

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat(i18n.language === 'ar' ? 'ar' : 'en-US', {
      style: 'currency',
      currency: 'EGP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  };

  // const x = Object.entries(methodTotals).map(([methodName, method]) => {
  //   return { methodName, ...method };
  // });
  // const incomeTotals = Object.entries(methodTotals).map(([methodName, method]) => {
  //   return { methodName, ...method };
  // }).filter(m => m.type === 'income');
  // const outcomeTotals = Object.entries(methodTotals).map(([methodName, method]) => {
  //   return { methodName, ...method };
  // }).filter(m => m.type === 'outcome');

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-6 mb-6">
      <h3 className="text-lg font-semibold text-slate-900 mb-4">
        {t('transactions.categoryTotals')}
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <h4 className="text-sm font-semibold text-green-600 mb-3">{t('transactions.income')}</h4>
          <div className="space-y-3">
            {Object.entries(categoryTotals).map(([categoryName, category], index) => (
              category.incomeCount ? <div key={index} className="flex items-center justify-between text-sm">
                <span className="text-slate-700">{t(categoryName === "deposit" ? `transactions.${categoryName}` : categoryName)}</span>
                <span className="font-medium text-green-600">
                  {formatCurrency(category.income)} ({category.incomeCount})
                </span>
              </div> : <></>
            ))}
          </div>
        </div>
        <div>
          <h4 className="text-sm font-semibold text-red-600 mb-3">{t('transactions.outcome')}</h4>
          <div className="space-y-3">
            {Object.entries(categoryTotals).map(([categoryName, category], index) => (
              category.outcomeCount ? <div key={index} className="flex items-center justify-between text-sm">
                <span className="text-slate-700">{t(categoryName === "deposit" ? `transactions.${categoryName}` : categoryName)}</span>
                <span className="font-medium text-red-600">
                  {formatCurrency(category.outcome)} ({category.outcomeCount})
                </span>
              </div> : <></>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
